import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

// Images
import Mobile2 from './images/Whofolio_on_mobile_2.png';

class Connect extends Component {
  render() {
    return (
      <div className="connect">

        <div className="wrap">

          <Fade left cascade>
          <div className="text-container">
            <h2><strong>connect</strong><br />with people</h2>
            <h3>Once you get started, you can start to build your contacts which will be invaluable for all your future interactions. Your contacts enable you to build teams.</h3>
          </div>
          </Fade>

          <Fade bottom>
          <img src={Mobile2} alt="whofolio Contacts page on a mobile phone" />
          </Fade>

        </div>

      </div>
    );
  }
}

export default Connect;



// WEBPACK FOOTER //
// ./src/assets/components/connect.js